import React from "react";
import {Route, Routes} from "react-router-dom";
import {handicaddieSelector} from "../../../services/store/asyncThunk";
import {SessionState} from "../../../services/store/reducers/session/slice";
import Dashboard from "../../dashboard/pages/Dashboard";
import {
    PLATFORM_CLUB_PREPAID_BAG_DASHBOARD,
    PLATFORM_DASHBOARD,
    PLATFORM_EDIT_PROFILE,
    PLATFORM_PURCHASE_SUCCESSFUL
} from "../../../services/PageUtils";
import ClubPrepaidBagDashboard from "../../prepaid/pages/ClubPrepaidBagDashboard";
import EditProfile from "../../profile/pages/EditProfile";
import CompletedPaymentStatus from "../../payments/pages/CompletedPaymentStatus";

interface Props {
    logOut: () => void
}

const PlatformApp = ({logOut}: Props) => {

    const { sessionState } = handicaddieSelector(state => state.session)

    return (
        <>
            {(sessionState !== SessionState.ACTIVE) &&
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    paddingTop: '3em',
                    textAlign: 'center'
                }}>
                    {/*<Spinner animation="border" variant="primary" />*/}
                    <h5>Loading...</h5>
                </div>
            }

            {(sessionState === SessionState.ACTIVE) && <Routes>
                <Route path={PLATFORM_PURCHASE_SUCCESSFUL} element={<CompletedPaymentStatus />} />
                <Route path={PLATFORM_CLUB_PREPAID_BAG_DASHBOARD} element={<ClubPrepaidBagDashboard />} />
                <Route path={PLATFORM_EDIT_PROFILE} element={<EditProfile />} />
                <Route path={PLATFORM_DASHBOARD} element={<Dashboard />} />
                <Route index element={<Dashboard />} />
            </Routes>}
        </>
    )

}

export default PlatformApp;